import { useEffect, useState } from 'react';
import { ALL_BLEACHING_YEARS } from 'utils/mapLayerSettings';

export default function useBleachingMapData(initialYear = ALL_BLEACHING_YEARS) {
  const [bleachingYears, setBleachingYears] = useState([]);
  const [bleachingObservations, setBleachingObservations] = useState(null);
  const [bleachingYear, setBleachingYear] = useState(initialYear);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const [yearsRes, obsRes] = await Promise.all([
          fetch('/api/public/bleaching-years.json'),
          fetch('/api/public/bleaching-observations.geojson'),
        ]);
        if (!yearsRes.ok || !obsRes.ok) return;
        const yearsData = await yearsRes.json();
        const obsData = await obsRes.json();
        const list = yearsData.years || [];
        setBleachingYears(list);
        setBleachingObservations(obsData);
        if (list.length && initialYear != null && !list.includes(initialYear)) {
          setBleachingYear(ALL_BLEACHING_YEARS);
        }
      } catch (_) {
        // Optional layer.
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [initialYear]);

  return {
    bleachingYears,
    bleachingObservations,
    bleachingYear,
    setBleachingYear,
    bleachingLoading: loading,
  };
}
